import dayjs from 'dayjs';

type AnalyticsOptions = {};

interface Analytics {
  track: (event: string, properties: any, options?: AnalyticsOptions) => void;
  page: (name: string, properties: any, options?: AnalyticsOptions) => void;
  identify: (userID: string, traits: any, options?: AnalyticsOptions) => void;
}

declare global {
  interface Window {
    analytics: Analytics;
  }
}

export const shouldSendAnalyticsEvents = (): boolean =>
  process.env.REACT_APP_ENVIRONMENT === 'production';

export const shouldLogAnalyticsEvents = () => {
  if (
    process.env.REACT_APP_ENVIRONMENT === 'development' &&
    process.env.REACT_APP_SHOW_ANALYTICS_LOGS === 'no'
  ) {
    return false;
  }

  return true;
};

const sessionID = dayjs().unix();

export const getDefaultAnalyticsOptions = (
  options?: AnalyticsOptions,
): AnalyticsOptions => {
  return {
    ...(options ?? {}),
    integrations: {
      Amplitude: {
        session_id: sessionID,
      },
    },
  };
};
